import KidoAPIInstance from "../../services/KidoConfigApi";

export const getDataCalculateCartApi = async () => {
	const path = "api/getDataCalculateCart";
	return await KidoAPIInstance.get(path);
};

export const getListHistoryOrderApi = async params => {
	const { fromDate, toDate, status, orderSource, type } = params;
	let path = `api/order/getList?fromDate=${fromDate}&toDate=${toDate}&type=${type}`;
	if (!!orderSource) {
		path += `&orderSource=${orderSource}`;
	}
	if (!!status) {
		path += `&status=${status}`;
	}
	return await KidoAPIInstance.get(path);
};

export const getListProductsApi = async params => {
	const url = "api/getProducts";
	let query = "";
	if (params) {
		const {
			business,
			keyword,
			requirePrice,
			count,
			offset,
			productBrandCodes
		} = params;
		query = `?requirePrice=${requirePrice}&isGetDistributorStock=true&count=${count}&offset=${offset}`;
		if (business) {
			query += `&business=${business}`;
		}
		if (keyword) {
			query += `&keyword=${keyword}`;
		}
		if (productBrandCodes) {
			query += `&productBrandCodes=${productBrandCodes}`;
		}
	}
	const path = `${url}${query}`;
	return await KidoAPIInstance.get(path);
};

export const getOrderHistoryDetailApi = async params => {
	const { business, id } = params;
	const path = `api/order/detail?business=${business}&id=${id}`;
	return await KidoAPIInstance.get(path);
};

export const postCalculateCartApi = async data => {
	const path = "api/calculateCart";
	return await KidoAPIInstance.post(path, data);
};

export const postCreateOrderApi = async data => {
	const path = "api/createOrder";
	return await KidoAPIInstance.post(path, data);
};

export const getMenuProductBrandsApi = async params => {
	const { business } = params;
	const path = `api/getProductBrands?business=${business}`;
	return await KidoAPIInstance.get(path);
};
